import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

export const findUserList = createAsyncThunk(
  "formsubmitted/findUserList",
  async (arg, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const userList = state.formSubmittedSlice.userList;
    let maxUpdate: number = 0;

    if (userList.length > 0) {
      const orderedList = [...userList].sort((a, b) => {
        if (a.updatedAt && b.updatedAt && a.updatedAt < b.updatedAt) {
          return -1;
        }
        if (a.updatedAt && b.updatedAt && a.updatedAt > b.updatedAt) {
          return 1;
        }
        return 0;
      });
      maxUpdate = orderedList[orderedList.length - 1].updatedAt!;
    }
    
    try {
      const params = {
        from: maxUpdate,
        limit: 50000,
        where: {
          sourceOrganization: state.userAuthentication.user?.sourceOrganization,
        }
      };
      const { data } = await axiosInstance.get(`${api.baseURL}userrole/get-reduce`, { params });
      
      let newList = [...userList.filter((element:any) => element.enabled === true)];

        data.forEach((element: any) => {
          if(newList.find(el => el.id === element.id)) {
            let user = newList.find(el => el.id === element.id);
            const indexToUpdate = newList.indexOf(user!);
            newList.splice(indexToUpdate, 1);
            newList.push(element);
          } else {
            newList.push(element);
          }
        });

        return newList;

    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
